import { z } from "zod";
/** Stable public identifier. Database sequence identifiers must never cross APIs. */
export const StableUuidSchema = z.string().uuid().brand();
//# sourceMappingURL=identifiers.js.map